import getPartnerBrandedHeader from 'yola-editor/src/js/modules/user/selectors/partner-branded-header';

const isBrandedHeaderFeatureEnabled = (state) => Boolean(getPartnerBrandedHeader(state));
export default isBrandedHeaderFeatureEnabled;
